import type { IntegrationType } from 'types/integrations';

export const allowedKeys = ['name', 'accountId', 'adAccountId', 'integrationId', 'status'] as const;

export enum AdAccountStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export type MetaAdAccount = {
  brandId: string;
  adAccountId: string;
  name: string;
  integrationId: string;
  properties?: {
    currency: string;
    acceptedTos: boolean;
  };
};

export type MasterTokenAdAccount = {
  name: string;
  adAccountId: string;
  accountId: string;
  properties: { acceptedTos: boolean };
  connected?: boolean;
};

export type AdAccountStore = {
  metaAdAccount: MetaAdAccount | null;
  tiktokAdAccount: AdAccount | null;
  clear: (type: IntegrationType) => void;
  updateAdAccount: <T extends IntegrationType>(
    adAccount: Partial<T extends IntegrationType.Facebook ? MetaAdAccount : AdAccount>,
    type: T
  ) => void;

  metaAdAccountsList: MetaAdAccount[];
  tiktokAdAccountsList: AdAccount[];
  getActiveAdAccountFromList: (type: IntegrationType) => MetaAdAccount | AdAccount | undefined;
  updateAdAcountsList: (adAccounts: (AdAccount | MetaAdAccount)[], type: IntegrationType) => void;

  masterTokenAdAccountsList: MasterTokenAdAccount[];
  clearMasterTokenAdAccounts: () => void;
  updateMasterTokenAdAccountsList: (adAccountsList: MasterTokenAdAccount[]) => void;
};

type Keys = (typeof allowedKeys)[number];

export type AdAccount = Omit<{ [key in Keys]: string }, 'status'> & { status: AdAccountStatus };
